// Wappen der Feuerwehr Dingharting — vereinfachte Nachbildung (blaues Schild,
// silbernes Kreuz, goldene Wellen / grüner Grund).
/*
export const Emblem = ({ className = "" }) => (
  <svg viewBox="0 0 100 120" className={className} aria-label="Wappen Dingharting" role="img">
    <path
      d="M6 4 H94 V70 C94 96 72 110 50 118 C28 110 6 96 6 70 Z"
      fill="#2F7DC2"
      stroke="#C9A227"
      strokeWidth="3"
    />
    {/ * Wellen / grüner Grund * /}
    <path d="M6 92 C24 84 34 100 50 92 C66 84 76 100 94 92 V70 C94 90 6 90 6 70 Z" fill="#C9A227" />
    <path d="M6 100 C24 92 34 108 50 100 C66 92 76 108 94 100 V118 C72 110 50 118 50 118 C28 110 6 100 6 100 Z" fill="#2E8B3D" />
    {/ * Silbernes Kreuz * /}
    <g fill="#E5E7EB" stroke="#9CA3AF" strokeWidth="1.5">
      <rect x="42" y="20" width="16" height="52" rx="1" />
      <rect x="24" y="38" width="52" height="16" rx="1" />
    </g>
  </svg>
);
*/

// import Logo from "/assets/final/Logo_FF-Dingharting_SchriftAlt.svg?react";
// export const Emblem = ({ className = "" }) => (
//   <Logo className={className} />
// );

export const Emblem = ({ className = "" }) => (
  <img
    src="/assets/final/Logo_FF-Dingharting_SchriftAlt.svg"
    alt="Feuerwehr Dingharting"
    className={className}
  />
);
